// extracted by mini-css-extract-plugin
module.exports = {"parallax":"__03-HeroA_parallax__HkD0f","overlay":"__03-HeroA_overlay__bCoFA"};